import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hobby",
  "description": "",
  "published": "2006-11-16T00:00:00.000Z",
  "redirect_from": ["/blog/hobby/swizec/356"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Some people choose the oddest things as their hobbies. Just look at these crazy gymnasts, they have four hours of practice a day, five days a week, and whereas most of us would call such strenous excercise hard, difficult, backbraking work, these nutters call it a rather pleasurable hobby, and they do it all out of pure love for... well for whatever they love about it.`}</p>
    <p>{`Here's to crazy nutters doing silly things all their lives `}{`*`}{`raises chalice`}{`*`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      